import { ExternalLinkedApplication } from '@user/store/authorization/typings'

export const helpAndSupport: ExternalLinkedApplication = {
  id: -1,
  name: 'Help and Support',
  appUrl: 'https://workwave.my.site.com/pestpac/s/sales-center',
}

export const analytics: ExternalLinkedApplication = {
  id: -2,
  name: 'Reports',
  appUrl: '',
}
